import { defineComponent as _defineComponent } from 'vue'
import { getInstance } from '@/auth/auth.js'


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginError',
  props: {
    error: null
  },
  setup(__props: any) {

const auth = getInstance()



const handleLogout = () => {
  auth.logout()
}
const navigateToSupportPage = () => {
  window.open('https://ironsight.app/support-resources', '_blank')
}

return { __sfc: true,auth, handleLogout, navigateToSupportPage }
}

})